module.exports = __webpack_public_path__ + "static/media/case-mob.58903276.svg";